module.exports = __webpack_public_path__ + "static/media/why-img.4637d116.png";